var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#C6C6C6;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "truck-fast-solid",
    className: "st0",
    d: "M17.94,10.56c-4.09,0-7.4,3.32-7.41,7.41v7.41H3.13c-1.36,0-2.47,1.11-2.47,2.47 c0,1.36,1.11,2.47,2.47,2.47h39.5c1.36,0,2.47,1.11,2.47,2.47c0,1.36-1.11,2.47-2.47,2.47H8.07c-1.36,0-2.47,1.11-2.47,2.47 c0,1.36,1.11,2.47,2.47,2.47h29.62c1.36,0,2.47,1.11,2.47,2.47c0,1.36-1.11,2.47-2.47,2.47H3.13c-1.36,0-2.47,1.11-2.47,2.47 c0,1.36,1.11,2.47,2.47,2.47h29.63c1.36,0,2.47,1.11,2.47,2.47c0,1.36-1.11,2.47-2.47,2.47H10.53v19.75 c0.07,8.18,6.75,14.76,14.93,14.69c8.09-0.07,14.62-6.6,14.69-14.69h19.75c0.07,8.18,6.75,14.76,14.93,14.69 c8.09-0.07,14.62-6.6,14.69-14.69h4.94c2.73-0.04,4.91-2.28,4.87-5.01c-0.04-2.67-2.2-4.83-4.87-4.87v-17.7 c0-2.62-1.03-5.13-2.89-6.99L79.66,28.26c-1.86-1.85-4.37-2.89-6.99-2.89h-7.82v-7.41c0-4.09-3.32-7.41-7.41-7.41H17.94z  M84.6,47.17v2.88H64.85V35.25h7.82L84.6,47.17z M25.35,67.34c4.09,0,7.41,3.32,7.41,7.41c0,4.09-3.32,7.41-7.41,7.41 s-7.41-3.32-7.41-7.41l0,0C17.94,70.66,21.26,67.34,25.35,67.34z M67.32,74.75c0-4.09,3.32-7.41,7.41-7.41s7.41,3.32,7.41,7.41 c0,4.09-3.32,7.41-7.41,7.41c0,0,0,0,0,0C70.63,82.15,67.32,78.84,67.32,74.75L67.32,74.75z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.f7007c4730ad56441a1661596583513c.svg";
export { ForwardRef as ReactComponent };